var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1C2154",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.248 12.409c.643 0 1.168-.205 1.635-.613.409-.41.643-.964.643-1.606 0-.643-.234-1.168-.643-1.577C5.445 8.204 4.891 8 4.248 8c-.642 0-1.168.204-1.576.613C2.204 9.022 2 9.547 2 10.19c0 .642.204 1.168.672 1.576.408.41.934.643 1.576.643zm9.752 0c.642 0 1.168-.205 1.635-.613.409-.41.642-.964.642-1.606 0-.643-.233-1.168-.642-1.577C15.197 8.204 14.642 8 14 8s-1.168.204-1.577.613c-.467.409-.671.934-.671 1.577 0 .642.204 1.168.671 1.576.41.41.935.643 1.577.643zm9.723 0c.642 0 1.168-.205 1.605-.613.438-.41.672-.964.672-1.606 0-.643-.234-1.168-.642-1.577C24.92 8.204 24.365 8 23.723 8c-.643 0-1.168.204-1.606.613-.438.409-.643.934-.643 1.577 0 .642.205 1.168.643 1.576.438.41.963.643 1.606.643z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMore);
export default __webpack_public_path__ + "static/media/icon-more.826b4023.svg";
export { ForwardRef as ReactComponent };